import { render, staticRenderFns } from "./Tabs2.vue?vue&type=template&id=6d57e8ae&"
import script from "./Tabs2.vue?vue&type=script&lang=js&"
export * from "./Tabs2.vue?vue&type=script&lang=js&"
import style0 from "./Tabs2.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports